// extracted by mini-css-extract-plugin
module.exports = {"modal":"suggestion_modal__modal___1rDSh","label":"suggestion_modal__label___bnrcX","modal-input":"suggestion_modal__modal-input___2t6rG"};